import { useMemo } from 'react'

import { DonutCard } from './DashboardCards'
import { categorySegments } from '../../../lib/composition'

import type { GisIssue } from '../../../api/types'
import type { BoardShortcuts } from '../../../hooks/useBoardShortcuts'

interface IssueTypeCardProps {
  /** Open issues in the current scope. */
  openIssues: GisIssue[]
  /** Cold-load flag (keepPreviousData keeps stale data during scope switches). */
  pending: boolean
  /** Selected category values (the dashboard filter). */
  selected: readonly string[]
  /** Toggle a category in/out of the dashboard filter. */
  onToggle: (category: string) => void
  go: BoardShortcuts
}

/**
 * "Issues by type" — the open load as a donut composition by issue category (top types + an "Other"
 * fold). Arcs/legend rows are **multi-select filters**: clicking a real category toggles it into the
 * dashboard filter; the "Other"/"Uncategorised" folds aren't a single value, so they're inert.
 */
export function IssueTypeCard({ openIssues, pending, selected, onToggle, go }: IssueTypeCardProps) {
  const segments = useMemo(() => categorySegments(openIssues), [openIssues])

  const pick = (key: string): void => {
    if (!key.startsWith('__')) {
      onToggle(key) // Other / Uncategorised (`__…`) aren't a single category — inert
    }
  }

  return (
    <DonutCard
      title="Issues by type"
      segments={segments}
      active={selected}
      centerValue={pending ? '—' : String(openIssues.length)}
      centerLabel="OPEN"
      onPick={pick}
      onOpen={() => go.goIssues()}
      openLabel="Open Issues board"
    />
  )
}
